import React from 'react';

const LocationSize = ({ text }) => {
  return <div className="text-base font-medium text-dark-blue">{text}</div>;
};

export default LocationSize;
